const getAppliedValues = size => (
    size.selectedSizes && size.selectedSizes.length > 0
        ? size.selectedSizes
        : []
);

export default getAppliedValues;
